(function (window) {
    const testId = 'AB-05';
    console.log(testId)
    waitFor(pageReady)
        .then(runVariant)
        .catch((err) => console.error(testId, err));

    function runVariant() {
        // once
        document.querySelector('.front-row > p').innerHTML = document.querySelector('.front-row > p').innerHTML.replace('Record Print', 'Price:')
        document.querySelector('.front-row > p').style.margin = 0;
        changeSaving();
        // every update
        // document.querySelectorAll('.front-row .badge').forEach(x => x.remove())
        // Seleciona o elemento alvo
        const targetNode = document.querySelector('span.discount.color-yellow');

        // Configura as opções de observação (neste caso, observamos alterações nos atributos e no conteúdo do texto)
        const config = { attributes: true, childList: true, subtree: true, characterData: true };

        // Define a callback para executar quando uma mutação for detectada
        const callback = function (mutationsList, observer) {
            for (const mutation of mutationsList) {
                if (mutation.type === 'childList') {
                    changeSaving();
                } else if (mutation.type === 'attributes') {
                    changeSaving();
                } else if (mutation.type === 'characterData') {
                    changeSaving();
                }
            }
        };

        // Cria uma instância do MutationObserver com a callback
        const observer = new MutationObserver(callback);

        // Começa a observar o elemento alvo com as opções de configuração especificadas
        if (targetNode) {
           
            observer.observe(targetNode, config);
        } else {
            console.log('AB05 not found!');
        }
    }

    function changeSaving() {
        // document.querySelector('.front-row .badge').textContent = 'SAVE: ' + document.querySelector('.front-row .discount.color-yellow').textContent.replace(' OFF', '');
        let newTotal = document.querySelector('.product__accordion_custom .price__container .price__sale .price-item.price-item--sale.price-item--last .money').textContent;
        let oldTotal = document.querySelector('.product__accordion_custom .price__container .price__sale .price-item.price-item--regular:not(.price-item--last) .money').textContent;
       
        // console.log(currecny_symbol);
        if (!newTotal || !oldTotal) return;
        newTotal = newTotal.replace(/[^\d.]/g, '');
        oldTotal = oldTotal.replace(/[^\d.]/g, '');
        // console.log(newTotal);
        const printValue = ((1 - (newTotal / oldTotal)) * 100).toFixed(2);
        document.querySelector('.front-row .badge').textContent = 'SAVE: ' + printValue + '%';
        // var conversionRate = Shopify.currency.rate;
        // console.log(conversionRate);
        // let final__price = oldTotal - newTotal;
        // let convert__currency_price = final__price * conversionRate;
        // console.log(conversionRate);
        // document.querySelector('.quantityRow span.discount.color-yellow').textContent = 'YOU SAVE $' + (oldTotal - newTotal).toFixed(2);
    }

    function pageReady() {
        return document.querySelector('.recordPrint .front-row');
    }


    function waitFor(condition, timeout) {
        const stopTime = typeof timeout === 'number' ? timeout : 7000;
        let stop = false;

        window.setTimeout(function () {
            stop = true;
        }, stopTime);

        // eslint-disable-next-line no-undef
        return new Promise(function (resolve, reject) {
            (function _innerWaitFor() {
                const value = condition();

                if (stop) {
                    reject();
                } else if (value) {
                    resolve(value);
                } else {
                    window.setTimeout(_innerWaitFor, 50);
                }
            })();
        });
    }
})(typeof unsafeWindow === 'undefined' ? window : unsafeWindow);